import React from "react"

import TwoColumnHeroWithImageRight, {
  CONTAINMENT_MODE,
} from "./_base/TwoColumnHeroWithImageRight"

import { ChildSelector } from "../helpers/ChildSelector"

import * as educationSectionWithListStyles from "../styles/EducationSectionWithList.module.css" 

export default function EducationSectionWithList(props) {
  const { content } = props

  const title = ChildSelector.select(
    content,
    `education-section-title`,
    ChildSelector.SELECTOR_TYPE.TEXT
  )

  const list = ChildSelector.select(
    content,
    `education-section-list`,
    ChildSelector.SELECTOR_TYPE.NODE
  )

  return (
    <div
    id={props.componentOriginalId || ``}
      className={`row ${props.className} ${educationSectionWithListStyles.wrapper}`}
    >
      <TwoColumnHeroWithImageRight
        contentClass={educationSectionWithListStyles.content}
        imageHolder={content}
        imageSelector={`education-section-image`}
        imageClass={educationSectionWithListStyles.featureImage}
        mode={CONTAINMENT_MODE.normal}
      >
        <h2
          className={educationSectionWithListStyles.title}
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        
        <div className={` ${educationSectionWithListStyles.listWrapper}`}>
          {list && (
            <div className={`${educationSectionWithListStyles.listHolder}`}>
              <ul className={`${educationSectionWithListStyles.content}`}>
                {list &&
                  list.childNodes &&
                  list.childNodes.length > 0 &&
                  list.childNodes.map((item, idx) => (
                    <li
                      key={idx}
                      className={`${educationSectionWithListStyles.contentItem}`}
                      dangerouslySetInnerHTML={{ __html: item.innerHTML }}
                    />
                  ))}
              </ul>
            </div>
          )}
        </div>
      </TwoColumnHeroWithImageRight>
    </div>
  )
}